/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getSalesActiveNumbersById } from 'core/api/sales.api';
import { IOrderData } from 'core/models/order.models';

export interface IState {
  isLoading: boolean
  error: object | null
  result: IOrderData
}

const initialState: IState = {
  result: {},
  error: null,
  isLoading: false,
};

export const getSalesActiveNumbersItemAction = createAsyncThunk(
  'getSalesActiveNumbersItemAction',
  async (id: string | number, { rejectWithValue }) => {
    try {
      const { data } = await getSalesActiveNumbersById(id);

      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  });

const salesGetActiveNumbersItemSlice = createSlice({
  name: 'getSalesActiveNumbersItem',
  initialState,
  reducers: {
    clear: () => initialState,
  },
  extraReducers(builder) {
    builder
      .addCase(
        getSalesActiveNumbersItemAction.pending,
        (state) => {
          state.result = {};
          state.isLoading = true;
        },
      )
      .addCase(
        getSalesActiveNumbersItemAction.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.result = action.payload;
        })
      .addCase(
        getSalesActiveNumbersItemAction.rejected,
        (state, action) => {
          state.result = {};
          state.isLoading = false;
          state.error = action.error;
        });
  },
});

export const { clear: clearGetActiveNumbersItemData } = salesGetActiveNumbersItemSlice.actions;

export const getSalesActiveNumbersItemReducer = salesGetActiveNumbersItemSlice.reducer;
